/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_MatchedInputs */

const en_story_bank_matched = /** @type {(inputs: Story_Bank_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matched`)
};

const de_story_bank_matched = /** @type {(inputs: Story_Bank_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matched`)
};

const fr_story_bank_matched = /** @type {(inputs: Story_Bank_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matched`)
};

const es_story_bank_matched = /** @type {(inputs: Story_Bank_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matched`)
};

const it_story_bank_matched = /** @type {(inputs: Story_Bank_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matched`)
};

const nl_story_bank_matched = /** @type {(inputs: Story_Bank_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matched`)
};

const pl_story_bank_matched = /** @type {(inputs: Story_Bank_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matched`)
};

const fi_story_bank_matched = /** @type {(inputs: Story_Bank_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matched`)
};

const da_story_bank_matched = /** @type {(inputs: Story_Bank_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matched`)
};

const sv_story_bank_matched = /** @type {(inputs: Story_Bank_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matched`)
};

/**
* | output |
* | --- |
* | "Matched" |
*
* @param {Story_Bank_MatchedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_matched = /** @type {((inputs?: Story_Bank_MatchedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_MatchedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_matched(inputs)
	if (locale === "fr") return fr_story_bank_matched(inputs)
	if (locale === "es") return es_story_bank_matched(inputs)
	if (locale === "it") return it_story_bank_matched(inputs)
	if (locale === "nl") return nl_story_bank_matched(inputs)
	if (locale === "pl") return pl_story_bank_matched(inputs)
	if (locale === "fi") return fi_story_bank_matched(inputs)
	if (locale === "da") return da_story_bank_matched(inputs)
	if (locale === "sv") return sv_story_bank_matched(inputs)
	return en_story_bank_matched(inputs)
});